{
  "nl": {
    "activities": {
      "labels": {
        "noProject": "Zonder project"
      }
    },
    "aiGenerated": {
      "label": "AI-gegenereerd",
      "tooltip": "Deze afbeelding is gemaakt met kunstmatige intelligentie"
    },
    "alerts": {
      "exampleButton": "Voorbeeld invoegen"
    },
    "appsInfo": {
      "shared": {
        "generalFeedback": "Algemene feedback",
        "introduction": "Dit hulpmiddel biedt je veel toepassingsmogelijkheden voor school en les:",
        "toolSpecificFaqs": "Vragen over het hulpmiddel {name}",
        "videoTutorial": "Zo werkt dit hulpmiddel"
      }
    },
    "authorInfoModal": {
      "creativeCommons": "Ze vallen onder de <a href='https://creativecommons.org/licenses/by/4.0/' target='_BLANK'>Creative Commons-licentie CC-BY 4.0</a>.",
      "header": "Over deze inhoud",
      "listHeader": "Je mag:",
      "listHtmlPublic": "<li><i class=\"bi bi-check2\"></i><strong>Delen</strong> — de inhoud in elk formaat of medium kopiëren en verder verspreiden.</li>\n<li><i class=\"bi bi-check2\"></i><strong>Bewerken</strong> — de inhoud remixen, wijzigen en erop voortbouwen voor elk doel, zelfs commercieel.</li>\n<li><i class=\"bi bi-exclamation-triangle\"></i>Bij verdere verwerking ben je verplicht om <strong>passende naamsvermeldingen</strong> te geven en <strong>{name} als auteur te noemen</strong>. Bij verdere verwerking binnen de fobizz Tools wordt automatisch aan deze voorwaarden voldaan.</li>",
      "paragraphHtmlIntro": "Deze inhoud is gemaakt door <strong>{name}</strong> met de <a href=\"https://app.fobizz.com/\" target=\"_blank\">fobizz Tools</a>.",
      "paragraphHtmlPrivate": "De inhoud mag <strong>alleen met uitdrukkelijke toestemming van {name}</strong> worden gedeeld, gekopieerd of verder verspreid.",
      "paragraphHtmlPrivateHead": "Deze inhoud is alleen <strong>voor bepaalde personen</strong> gedeeld via een deellink.",
      "paragraphHtmlPublic": "Deze inhoud is gemaakt op basis van de <a href='{link}' target='_BLANK'>inhoud van <strong>{name}</strong></a>."
    },
    "buttons": {
      "add": "Toevoegen",
      "apply": "Gebruiken",
      "cancel": "Annuleren",
      "chooseFile": "Bestand selecteren",
      "clearSearch": "Zoekopdracht resetten",
      "close": "Sluiten",
      "copy": "Kopiëren",
      "copySmall": "kopiëren",
      "createContent": "Inhoud aanmaken",
      "delete": "Verwijderen",
      "deleteImage": "Afbeelding verwijderen",
      "edit": "Bewerken",
      "enableRecordingDevice": "Opnameapparaat activeren",
      "finished": "Gereed",
      "generatePreviewImage": "Afbeelding genereren",
      "generateSuggestion": "Voorstel genereren",
      "generateText": "Tekst genereren",
      "go": "Aan de slag",
      "insert": "Invoegen",
      "insertElement": "Element invoegen",
      "loadMore": "Meer laden",
      "move": "Verplaatsen",
      "next": "Verder",
      "previous": "Terug",
      "reRecord": "Opname herstarten",
      "reload": "Opnieuw laden",
      "save": "Opslaan",
      "select": "Selecteren",
      "startRecording": "Opname starten",
      "stopRecording": "Opname stoppen",
      "submit": "Verzenden",
      "toggleFilterMenu": "Filtermenu tonen/verbergen",
      "tryAgain": "Opnieuw proberen",
      "understood": "Begrepen",
      "uploadAnotherFile": "Ander bestand uploaden",
      "uploadFile": "Bestand uploaden",
      "useToolsUnlimited": "fobizz onbeperkt gebruiken",
      "no": "Nee",
      "yes": "Ja"
    },
    "confirmDialog": {
      "discardItem": {
        "confirm": "Verplaatsen",
        "text": "De inhoud ({modelName}) wordt uit je overzicht verwijderd. Je vindt deze daarna in de prullenbak.",
        "title": "Inhoud naar de prullenbak verplaatsen?"
      },
      "promptCheckCancel": "Aanpassen",
      "promptContentFilter": {
        "confirm": "Verzenden",
        "text": "Onze veiligheidsfilters hebben je invoer als gevoelig geclassificeerd. Je kunt deze aanpassen of ongewijzigd verzenden.",
        "title": "Invoer geblokkeerd"
      },
      "promptPrivacy": {
        "confirm": "Verzenden",
        "text": "Je prompt lijkt persoonsgegevens te bevatten. Bij het verzenden wordt deze naar de AI overgedragen.",
        "title": "Persoonsgegevens in de prompt?"
      }
    },
    "confirms": {
      "reRecord": {
        "confirm": "Verwerpen & opnieuw starten",
        "text": "Je huidige opname wordt verwijderd zodat je een nieuwe kunt starten.",
        "title": "Opname opnieuw starten?"
      },
      "unsavedChanges": {
        "discard": "Verwerpen",
        "text": "Je hebt niet-opgeslagen wijzigingen. Wil je ze opslaan?",
        "title": "Niet-opgeslagen wijzigingen"
      }
    },
    "courses": {
      "labels": {
        "completed": "Voltooid",
        "course": "Nascholing",
        "enrolled": "Ingeschreven",
        "impulse": "Impuls",
        "recording": "Opname",
        "webinar": "Webinar",
        "workshop": "Workshop",
        "b2bWorkshop": "Schoolintern"
      }
    },
    "emptyState": {
      "ai": {
        "noHistoryDescription": "Probeer gerust de AI-tools uit om nieuwe inhoud te maken.",
        "noHistoryTitle": "Je hebt nog geen aanvragen gedaan."
      }
    },
    "enums": {
      "autoCleanup": {
        "day": "1 dag",
        "month": "1 maand",
        "months_18": "18 maanden",
        "never": "Nooit",
        "week": "1 week",
        "year": "1 jaar"
      },
      "companyKinds": {
        "kind_school": "School",
        "kind_community_college": "Volkshogeschool",
        "kind_other": "Overig",
        "kind_teacher_training": "Studie-seminar/lerarenopleiding",
        "kind_institute": "Nascholingsinstituut",
        "kind_media_center": "Mediacentrum",
        "kind_college": "Universiteit/hogeschool",
        "kind_company": "Bedrijf/organisatie",
        "kind_government_agency": "Overheid/bestuur",
        "kind_national_license": "Landelijke licentie",
        "kind_goethe_institute": "Goethe-Instituut",
        "kind_supporting_institution": "Schoolbestuur",
        "kind_tutoring": "Bijles",
        "kind_language_school": "Taalschool"
      },
      "courseTargetGroupTypes": {
        "TARGET_GROUP_TYPE_TEACHERS": "Docenten",
        "TARGET_GROUP_TYPE_SCHOOL_BOARDS": "Schoolleiding",
        "TARGET_GROUP_TYPE_SCHOOL_EXECUTIVES": "Docenten in leidinggevende positie",
        "TARGET_GROUP_TYPE_TEACHER_TRAINEES": "Leraren-in-opleiding",
        "TARGET_GROUP_TYPE_STUDENT_TEACHERS": "Stagiairs",
        "TARGET_GROUP_TYPE_SCHOOL_LEADERS": "Schoolleiders"
      },
      "gradeLevels": {
        "GRADE_LEVEL_1_2": "Groep 1/2",
        "GRADE_LEVEL_3_4": "Groep 3/4",
        "GRADE_LEVEL_HIGH": "Bovenbouw",
        "GRADE_LEVEL_LOWER": "Onderbouw",
        "GRADE_LEVEL_MIDDLE": "Middenbouw"
      },
      "international": {
        "false": "Duitstalig schoolsysteem",
        "true": "Engelstalig schoolsysteem"
      },
      "itemNodes": {
        "AudioRecorder::File": "Audio-opname",
        "LinkShortener::Link": "Link verkorten",
        "ScreenRecorder::File": "Schermopname",
        "Tools::Ai::Assistant": "AI-assistent",
        "Tools::Ai::Converter": "Inhoud",
        "Tools::Ai::Feedback": "AI-correctiehulp",
        "Tools::Ai::Image": "AI-beeld",
        "Tools::ClassroomScreen::Screen": "Digitaal bord",
        "Tools::FileSharing::File": "Bestand delen",
        "Tools::Pinboard::Board": "Prikbord",
        "Tools::Pinboard::Card": "Prikbord",
        "Tools::Pinboard::Comment": "Prikbord",
        "Tools::Pinboard::List": "Prikbord",
        "Tools::PupilFeedback::Assignment": "AI-feedback",
        "Tools::PupilFeedback::Feedback": "AI-feedback",
        "Tools::Surveys::Survey": "Enquête",
        "Tools::Surveys::SurveyResponse": "Enquête",
        "Tools::TextEditor::Document": "Tekstdocument",
        "Tools::Website::Page": "Website",
        "Tools::WordClouds::WordCloud": "Woordwolk",
        "Tools::WordClouds::WordEntry": "Woordwolk",
        "Tools::Worksheet::Response": "Inlevering",
        "Tools::Worksheet::Worksheet": "Werkblad",
        "VideoRecorder::File": "Video-opname",
        "folder": "Map"
      },
      "languages": {
        "de": "Duits",
        "en": "Engels",
        "es": "Spaans",
        "fr": "Frans",
        "it": "Italiaans",
        "nl": "Nederlands",
        "ru": "Russisch",
        "ua": "Oekraïens"
      },
      "privacyLevel": {
        "locked": "Geblokkeerd",
        "members_only": "Alleen leden",
        "password_protected": "Beschermd met wachtwoord",
        "public_for_all": "Beschikbaar als OER",
        "secret": "Zichtbaar"
      },
      "profileGradeTypes": {
        "GRADE_TYPE_ELEMENTARY_SCHOOL": "Basisschool",
        "GRADE_TYPE_LOWER_GRADE": "Onderbouw",
        "GRADE_TYPE_MIDDLE_LEVEL": "Middenbouw",
        "GRADE_TYPE_OTHER": "Overig",
        "GRADE_TYPE_SPECIAL_SCHOOL": "Speciaal onderwijs",
        "GRADE_TYPE_UPPER_SCHOOL": "Bovenbouw",
        "GRADE_TYPE_VOCATIONAL_SCHOOL": "Beroepsschool"
      },
      "schoolTypes": {
        "SCHOOL_TYPE_ACADEMIC_HIGH_SCHOOL": "Gymnasium",
        "SCHOOL_TYPE_COMPREHENSIVE_SCHOOL": "Scholengemeenschap",
        "SCHOOL_TYPE_CUSTOM": "Overig",
        "SCHOOL_TYPE_ELEMENTARY_SCHOOL": "Basisschool",
        "SCHOOL_TYPE_MAIN_SCHOOL": "Hoofd-/middelbare school",
        "SCHOOL_TYPE_MIDDLE_SCHOOL": "Realschool",
        "SCHOOL_TYPE_SECONDARY_SCHOOL": "Voortgezet onderwijs",
        "SCHOOL_TYPE_SPECIAL_SCHOOL": "Speciaal onderwijs",
        "SCHOOL_TYPE_UNIVERSITY": "Hogeschool/universiteit",
        "SCHOOL_TYPE_VOCATIONAL_SCHOOL": "Beroepsschool"
      },
      "subjectTypes": {
        "SUBJECT_TYPE_ART": "Kunst",
        "SUBJECT_TYPE_BIOLOGY": "Biologie",
        "SUBJECT_TYPE_CHEMISTRY": "Scheikunde",
        "SUBJECT_TYPE_COMPUTER_SCIENCE": "Informatica",
        "SUBJECT_TYPE_ECONOMY": "Economie",
        "SUBJECT_TYPE_ENGLISH": "Engels",
        "SUBJECT_TYPE_ESL": "DaZ/DaF",
        "SUBJECT_TYPE_ETHICS": "Ethiek",
        "SUBJECT_TYPE_FOREIGN_LANGUAGES": "Vreemdetalendidactiek",
        "SUBJECT_TYPE_GEOGRAPHIE": "Aardrijkskunde",
        "SUBJECT_TYPE_GERMAN": "Duits",
        "SUBJECT_TYPE_HISTORY": "Geschiedenis",
        "SUBJECT_TYPE_MATH": "Wiskunde",
        "SUBJECT_TYPE_MEDIA": "Media",
        "SUBJECT_TYPE_MUSIC": "Muziek",
        "SUBJECT_TYPE_NATURAL_SCIENCES": "Natuurwetenschappen",
        "SUBJECT_TYPE_OTHER": "Overig",
        "SUBJECT_TYPE_PERSONAL_EDUCATION": "Wereldoriëntatie",
        "SUBJECT_TYPE_PHILOSOPHIE": "Filosofie",
        "SUBJECT_TYPE_PHYSICS": "Natuurkunde",
        "SUBJECT_TYPE_POLITICS": "Maatschappij/Politiek",
        "SUBJECT_TYPE_RELIGION": "Godsdienst",
        "SUBJECT_TYPE_SPORT": "Sport",
        "SUBJECT_TYPE_TECHNOLOGY": "Techniek",
        "SUBJECT_TYPE_UNSPECIFIC": "Vakoverstijgend"
      }
    },
    "flash": {
      "addFileSuccess": "Bestand {filename} toegevoegd",
      "errorOccurred": "Er is een fout opgetreden. Probeer het opnieuw.",
      "premiumLimitWarning": "Nog maar één premium-aanvraag voor vandaag over | Nog maar {count} premium-aanvragen voor vandaag over",
      "premiumLimitResetsAtMidnight": "De limiet wordt om middernacht gereset.",
      "premiumLimitFallback": "Premium-limiet voor vandaag bereikt",
      "premiumLimitFallbackDescription": "{model} neemt het tot middernacht over.",
      "premiumLimitReached": "Premium-limiet voor vandaag bereikt",
      "premiumLimitReachedDescription": "Vanaf middernacht kun je weer premium-modellen gebruiken.",
      "alreadyLoggedIn": "Je bent al ingelogd",
      "bookmarkSuccess": "Toegevoegd aan verlanglijst",
      "connectionReestablished": "Verbinding is hersteld",
      "paidLicenseRequired": "Voor deze tool heb je een betaalde licentie nodig",
      "remixStarted": "\"{name}\" wordt geremixt",
      "remixSuccess": "\"{name}\" is aangemaakt",
      "removeFileSuccess": "Bestand {filename} verwijderd",
      "successfullyCreated": "Succesvol aangemaakt",
      "successfullyDeleted": "Succesvol verwijderd",
      "successfullyUpdated": "Succesvol bijgewerkt",
      "templateMarkSuccess": "{name} gemarkeerd als sjabloon",
      "tooManyRequests": "Te veel aanvragen. Probeer het over een paar seconden opnieuw.",
      "templateUnmarkSuccess": "{name} niet langer gemarkeerd als sjabloon",
      "unbookmarkSuccess": "Verwijderd uit verlanglijst",
      "undiscardItemSuccess": "\"{name}\" is hersteld"
    },
    "footer": {
      "aboutUs": "Over fobizz",
      "aiAndTools": "AI en Tools",
      "aiAndToolsHelp": "Hulp bij Tools & AI-toepassingen",
      "aiGuidelines": "Omgaan met AI (EU AI Act)",
      "alternativeText": "Databeschermingszegel dat een hoge en gecontroleerde gegevensbescherming garandeert",
      "certificatesHelp": "Hulp bij certificaten",
      "company": "Bedrijven",
      "courses": "Cursussen",
      "coursesHelp": "Hulp bij cursussen en webinars",
      "enrollmentHelp": "Hulp bij inschrijvingen",
      "freeTrial": "Gratis proeftoegang",
      "appStoreAriaLabel": "Download in de App Store",
      "getTheApp": "Download nu de app:",
      "googlePlayAriaLabel": "Downloaden bij Google Play",
      "gettingStarted": "Tips om te starten met fobizz",
      "helpAndContact": "Hulp en Contact",
      "imprint": "Impressum",
      "jobs": "Vacatures",
      "language": "Taal",
      "legal": "Juridisch",
      "licenses": "Licenties",
      "newsletter": "Abonneer op de nieuwsbrief",
      "partners": "Onze Partners",
      "partnersHelp": "Hulp bij de partners",
      "privacyPolicy": "Gegevensbescherming",
      "schoolLicensePrices": "Prijzen voor school- en groepslicenties",
      "shareWithColleagues": "Inhoud delen met collega's",
      "shareWithStudents": "Inhoud delen met leerlingen",
      "singleLicensePrices": "Prijzen voor individuele licenties",
      "tAndC": "Algemene Voorwaarden",
      "teachingMaterial": "Lesmateriaal",
      "teachingMaterialHelp": "Hulp bij lesmaterialen",
      "team": "Team",
      "technicalHelp": "Eerste hulp bij problemen",
      "toTeach": "fobizz en to teach",
      "urls": {
        "aboutUs": "https://fobizz.com/de/was-ist-fobizz/",
        "aiAndTools": "https://app.fobizz.com",
        "aiAndToolsHelp": "https://app.fobizz.com/de/help/categories/54-fobizz-tools",
        "aiGuidelines": "https://app.fobizz.com/de/help/categories/60-k-guidelines",
        "certificatesHelp": "https://app.fobizz.com/de/help/articles/78-weiterbildung-zertifikat-erhalten",
        "courses": "https://app.fobizz.com/fortbildungen",
        "coursesHelp": "https://app.fobizz.com/de/help/categories/50-fortbildungen",
        "enrollmentHelp": "https://app.fobizz.com/de/help/articles/311-kurs-einschreiben",
        "freeTrial": "https://app.fobizz.com/de/help/articles/310-fobizz-kostenfrei-testen",
        "gettingStarted": "https://app.fobizz.com/de/help/articles/133-start-empfehlungen",
        "helpAndContact": "https://app.fobizz.com/de/help",
        "imprint": "https://app.fobizz.com/imprints",
        "jobs": "https://fobizz.com/de/unsere-jobs/",
        "licenses": "https://app.fobizz.com/de/help/articles/273-kosten-fobizz",
        "newsletter": "https://fobizz.com/de/neuigkeiten-per-newsletter",
        "partners": "https://app.fobizz.com/partners",
        "partnersHelp": "https://app.fobizz.com/de/help/categories/56-unsere-partner",
        "privacyPolicy": "https://app.fobizz.com/data_protections",
        "schoolLicensePrices": "https://app.fobizz.com/de/help/articles/102-schullizenz-preise-und-paketgroessen",
        "shareWithColleagues": "https://app.fobizz.com/de/help/articles/26-wie-kann-ich-materialien-mit-meinen-kolleg-innen-teilen",
        "shareWithStudents": "https://app.fobizz.com/de/help/articles/20-inhalte-mit-schueler-innen-teilen",
        "singleLicensePrices": "https://app.fobizz.com/de/help/articles/279-abo-einzelizenz",
        "teachingMaterial": "https://app.fobizz.com/gallery",
        "teachingMaterialHelp": "https://app.fobizz.com/de/help/categories/59-unterrichtsmaterialien",
        "team": "https://fobizz.com/de/team/",
        "technicalHelp": "https://app.fobizz.com/de/help/categories/62-technische-probleme",
        "termsAndConditions": "https://app.fobizz.com/terms_and_conditions",
        "toTeach": "https://fobizz.com/de/to-teach/",
        "useToolsWithStudents": "https://app.fobizz.com/de/help/articles/309-tools-schueler-innen-nutzen"
      },
      "useToolsWithStudents": "Tools gebruiken met leerlingen"
    },
    "global": {
      "all": "Alles",
      "emptyFilterHeading": "Helaas hebben we geen passende inhoud kunnen vinden.",
      "emptyFilterText": "Probeer het gerust met een andere term of pas het filter aan.",
      "filterContent": "Inhoud filteren",
      "resetFilter": "Filter resetten"
    },
    "headers": {
      "aiImageSearch": "Mijn AI Afbeeldingen",
      "auto_cleanup": "Automatische verwijdering",
      "background": "Achtergrond",
      "backgroundColor": "Achtergrondkleur",
      "backgroundPreview": "Achtergrondvoorbeeld",
      "camera": "Camera",
      "colorAndPattern": "Kleur en patroon",
      "colors": "Kleuren",
      "editFolder": "Map bewerken",
      "files": "Bestanden",
      "hint": "Opmerking",
      "image": "Afbeelding",
      "imageSearch": "Afbeelding zoeken",
      "imageUploadHint": "Je kunt het nu op het werkblad zien",
      "imageUploadSuccess": "Afbeelding succesvol geüpload.",
      "images": "Afbeeldingen",
      "previewImage": "Miniatuurweergave",
      "latex": "LaTeX",
      "link": "Link",
      "microphone": "Microfoon",
      "patterns": "Patroon",
      "recording": "Opname",
      "settings": "Instellingen",
      "share": "Delen",
      "statistics": "Statistieken",
      "toolSpecificFaqs": "Vragen over tool {name}",
      "videoTutorial": "Zo werkt deze tool",
      "views": "Weergaven",
      "visitorPermissions": "Bezoekersrechten"
    },
    "feedback": {
      "thumbsDown": "Niet behulpzaam",
      "thumbsUp": "Vind ik leuk"
    },
    "help": {
      "autoCleanup": {
        "day": "Gegevens worden na één dag verwijderd.",
        "month": "Gegevens worden na één maand verwijderd.",
        "never": "Gegevens worden niet automatisch verwijderd.",
        "week": "Gegevens worden na één week verwijderd."
      },
      "embed": "Kopieer het codefragment om het via iframe in andere websites in te sluiten.",
      "jsRequired": "JavaScript is vereist",
      "maxCharacters": "Maximaal {max} tekens",
      "privacyLevel": {
        "locked": "Verberg de inhoud achteraf of tijdelijk. Alleen jij kunt ze zien en bewerken.",
        "members_only": "Niet openbaar. Alleen ingelogde leden hebben toegang.",
        "password_protected": "Bescherm de inhoud extra met een wachtwoord.",
        "public_for_all": "Publiceer de inhoud als OER in de fobizz galerie voor lesmateriaal. <a href=\"/gallery/how_to\" target=\"_blank\">Meer informatie</a>",
        "secret": "Alleen personen aan wie je de link stuurt, kunnen de inhoud verder gebruiken."
      },
      "visitorPermissions": {
        "visitor_permissions_invisible": "Bezoekers kunnen inhoud niet zien.",
        "visitor_permissions_read": "Bezoekers kunnen inhoud zien.",
        "visitor_permissions_write": "Bezoekers kunnen inhoud bewerken."
      }
    },
    "hints": {
      "allowedFileTypes": "Toegestane bestandstypen",
      "converting": "Bestand wordt omgezet...",
      "copied": "Gekopieerd naar klembord",
      "creating": {
        "docx": "Word-document wordt gemaakt...",
        "pdf": "PDF wordt gemaakt...",
        "pptx": "PowerPoint-presentatie wordt gemaakt..."
      },
      "dataProtectionFileUpload": "Upload geen gevoelige of persoonlijke informatie en respecteer de auteursrechten bij het gebruik van inhoud van anderen.",
      "dataProtectionFileUploadTitle": "Bescherm je gegevens bij het uploaden van bestanden",
      "dragDrop": "Tip: Je kunt een bestand direct uploaden via drag & drop",
      "dragOrSelectFile": "Sleep hier een afbeelding naartoe of",
      "dragOrSelectImage": "Sleep hier een afbeelding naartoe of selecteer er een",
      "imageUploading": "Afbeelding wordt geüpload...",
      "drop": "Laat hier het bestand vallen",
      "dropFile": "Sleep hier een bestand naartoe of",
      "embedIFrame": "Door op deze voorbeeldafbeelding te klikken ga je ermee akkoord dat de weergegeven inhoud wordt geladen en dat de benodigde gegevens, met name je IP-adres, aan de aanbieder van de inhoud worden doorgegeven. Meer informatie vind je in onze privacyverklaring.",
      "embedIFramePupil": "Door op deze voorbeeldafbeelding te klikken wordt de weergegeven inhoud geladen en worden de benodigde gegevens, met name je IP-adres, aan de aanbieder van de inhoud doorgegeven. Twijfel je? Vraag dan je docent.",
      "exampleAlert": "Hoe kan dat eruitzien?",
      "exampleButton": "Voorbeeld invoegen",
      "fileLimit": "(maximaal {size} MB)",
      "inputLabel": "Jouw prompt",
      "latexSyntax": "Je kunt <a href=\"https://katex.org/docs/supported\" target=\"_blank\">LaTeX-syntaxis</a> gebruiken",
      "legacyBrowserBanner": "Het lijkt erop dat je een verouderde browser gebruikt. Update je browser om onze website volledig te kunnen gebruiken. Met een actuele browser verbeter je niet alleen je beveiliging, maar ook de weergave en functionaliteit van onze site.",
      "loading": "Laden...",
      "maxFileSize": "Maximaal {size} MB",
      "maxRecordingLength": "Opnames kunnen maximaal 4 minuten duren.",
      "noItems": "Je hebt hier nog niets aangemaakt. Begin nu!",
      "noOptions": "De lijst is leeg",
      "noResults": "Geen resultaten gevonden",
      "notSpecified": "Nog geen opgave",
      "ready": {
        "docx": "Word-document beschikbaar gesteld",
        "pdf": "PDF beschikbaar gesteld",
        "pptx": "PowerPoint-presentatie beschikbaar gesteld"
      },
      "previewImageDragDrop": "Sleep hier een afbeelding naartoe of klik om te uploaden",
      "progressMessage": "Bezig met verwerken...",
      "progressMessageQueued": "In wachtrij...",
      "prompt": "Belangrijk: deel nooit persoonlijke gegevens met de AI en controleer de antwoorden kritisch.",
      "selectFile": "Bestand selecteren",
      "serverStatus": "Het is momenteel druk en onze tools zijn zwaar belast. Het kan zijn dat je verzoek langer duurt dan normaal. Bedankt voor je geduld. We werken er al aan om het systeem weer op normale snelheid te laten werken.",
      "settingsSaved": "Je instellingen zijn opgeslagen.",
      "submittingDescription": "Mocht het langer duren: het proces loopt op de achtergrond door. Je kunt ondertussen iets anders doen en het resultaat vind je rechtsboven in de geschiedenis.",
      "uploading": "Bestand wordt geüpload...",
      "uploadingProgress": "Bestand wordt geüpload: {progress}",
      "visitorMaterial": "Je gebruikt fobizz als gast - alle inhoud wordt na 2 dagen verwijderd. <strong><a href=\"{url}\" target=\"_blank\">Log in</a></strong> om je inhoud op te slaan."
    },
    "infoModal": {
      "classroom_screen": "<h3><strong>Lesplan</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Thema</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Naam / Thema van de lessenserie</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Aanbevolen tijd</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>bijv. 45/90 minuten</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Leerdoel</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Wat is het voornaamste doel van het lesuur? Welke competentieverwerving/-toename moet aan het einde van het lesuur worden bereikt?</em></p></td></tr></tbody></table><p></p><h3><strong>Lesverloop</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Duur (min)</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Fase</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Lesgebeuren / Docent-leerling-interactie</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Sociale vorm / Werkvorm</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Media / Materialen</strong></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>5</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Introductie</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>10</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Verwerking</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td></tr></tbody></table><p></p><p><strong>Overige informatie</strong></p><p><em>Beschrijving van de inhoud en het verloop van de lessenserie. Aanwijzingen voor de uitvoering en voorbereiding van de les. Eventueel toelichting op de relatie met het leerplan en didactisch-methodische keuzes.</em></p><p></p>",
      "title": "Extra informatie voor docenten"
    },
    "labels": {
      "aiEnabled": "AI geactiveerd",
      "authorName": "Auteur",
      "confirm": "Bevestigen",
      "continue": "Verder",
      "customSubjectType": "Overig schoolvak",
      "description": "Beschrijving",
      "notSpecified": "Niet opgegeven",
      "gradeLevels": "Leerjaren",
      "imageSearch": {
        "categories": "Dieren, dinosauriërs, natuur, landschap, strand, zee, hemel, ruimte, auto, objecten, mode, kantoor, kinderen, mensen, familie, verhalen",
        "noMoreResults": "Geen verdere afbeeldingen gevonden"
      },
      "international": "Inhoud voor",
      "itemTotals": "{firstItem} - {lastItem} van {totalCount} items",
      "language": "Taal",
      "latex": "LaTeX-invoer",
      "loading": "Laden...",
      "name": "Naam",
      "new": "Nieuw",
      "nextPage": "Volgende pagina",
      "page": "Pagina",
      "previousPage": "Vorige pagina",
      "password": "Wachtwoord",
      "preview": "Voorbeeld",
      "pseudonym": "Voer hier je pseudoniem of naamafkorting in.",
      "schoolTypes": "Schooltypen",
      "search": "Zoeken",
      "subjectTypes": "Schoolvakken",
      "title": "Titel",
      "withAi": "Met AI"
    },
    "languages": {
      "de": "Duits",
      "en": "Engels",
      "es": "Spaans",
      "fr": "Frans"
    },
    "limitUpsellBox": {
      "bodySubtitleHtml": "Beveel je collega's de <strong>fobizz Schoollicentie</strong> aan of haal de <strong>Individuele Licentie</strong> alleen voor jou.",
      "bodyTitle": "Wil je fobizz onbeperkt gebruiken?",
      "header": {
        "ai_assistant": {
          "multiple": "<strong>{more} {number} assistenten</strong> aanmaken",
          "one": "<strong>nog een assistent</strong> aanmaken"
        },
        "ai_chat": {
          "multiple": "door de AI-Chat <strong>{more} {number} antwoorden</strong> laten geven",
          "one": "door de AI-Chat <strong>nog een antwoord</strong> laten geven"
        },
        "ai_chat_completion": {
          "multiple": "<strong>{more} {number} antwoorden</strong> van de AI-Chat ontvangen",
          "one": "<strong>een antwoord</strong> van de AI-Chat ontvangen"
        },
        "ai_converter": {
          "multiple": "<strong>{more} {number} verzoeken</strong> aan de AI-Multimediatool indienen",
          "one": "<strong>nog een verzoek</strong> aan de AI-Multimediatool indienen"
        },
        "ai_document_qa": {
          "multiple": "<strong>{more} {number} documenten</strong> uploaden voor de AI voor Documenten",
          "one": "<strong>nog een document</strong> uploaden voor de AI voor Documenten"
        },
        "ai_feedback": {
          "multiple": "<strong>{more} {number} verzoeken</strong> aan de AI-Begeleidingshulp indienen",
          "one": "<strong>nog een verzoek</strong> aan de AI-Begeleidingshulp indienen"
        },
        "ai_image": {
          "multiple": "<strong>{more} {number} afbeeldingen</strong> aanmaken",
          "one": "<strong>een afbeelding</strong> aanmaken"
        },
        "ai_mini_tool": {
          "multiple": "<strong>{more} {number} verzoeken</strong> aan het Promptlab indienen",
          "one": "<strong>nog een verzoek</strong> aan het Promptlab indienen"
        },
        "ai_persona": {
          "multiple": "<strong>{more} {number} verzoeken</strong> aan de AI voor Personen indienen",
          "one": "<strong>nog een verzoek</strong> aan de AI voor Personen indienen"
        },
        "audio_recorder": {
          "multiple": "<strong>{more} {number} audio-opnames</strong> maken",
          "one": "<strong>nog een audio-opname</strong> maken"
        },
        "classroom_screen": {
          "multiple": "<strong>{more} {number} lesborden</strong> aanmaken",
          "one": "<strong>nog een lesbord</strong> aanmaken"
        },
        "file_sharing": {
          "multiple": "<strong>{more} {number} bestanden</strong> delen",
          "one": "<strong>nog een bestand</strong> delen"
        },
        "licenseRequiredHtml": "<h2>Om deze tool te gebruiken, heb je een fobizz-licentie nodig.</h2><p>Informeer naar onze licenties voor onbeperkt gebruik.</p>",
        "limitReachedHtml": "<h2>Je hebt je maandelijkse limiet voor deze tool bereikt.</h2><p>Informeer naar onze licenties voor onbeperkt gebruik.</p>",
        "limitReachedVisitor": "Je hebt je dagelijkse limiet aan antwoorden van de AI-Assistent verbruikt.",
        "link_shortener": {
          "multiple": "<strong>{more} {number} links</strong> verkorten",
          "one": "<strong>nog een link</strong> verkorten"
        },
        "monthlyLimitNotReached": "Je kunt deze maand nog {actionText}.",
        "monthlyLimitNotReachedVisitor": "Als gast kun je deze maand nog {actionText}",
        "more": "meer",
        "pinboard": {
          "multiple": "<strong>{more} {number} prikborden</strong> aanmaken",
          "one": "<strong>nog een prikbord</strong> aanmaken"
        },
        "pupil_feedback": {
          "multiple": "<strong>{more} {number} taken</strong> aanmaken met de AI voor Feedback",
          "one": "<strong>nog een taak</strong> aanmaken met de AI voor Feedback"
        },
        "qrcodes": {
          "multiple": "<strong>{more} {number} QR-codes</strong> aanmaken",
          "one": "<strong>nog een QR-code</strong> aanmaken"
        },
        "registerNow": "<strong><a href=\"{url}\" target=\"_blank\">Registreer je gratis</a></strong> om verder te werken met de tools.",
        "school_classes": {
          "multiple": "<strong>{more} {number} klaslokalen</strong> aanmaken",
          "one": "<strong>nog een klaslokaal</strong> aanmaken"
        },
        "screen_recorder": {
          "multiple": "<strong>{more} {number} schermopnames</strong> maken",
          "one": "<strong>nog een schermopname</strong> maken"
        },
        "shared_space_link": {
          "multiple": "<strong>{more} {number} klaslokalen</strong> aanmaken",
          "one": "<strong>nog een klaslokaal</strong> aanmaken"
        },
        "surveys": {
          "multiple": "<strong>{more} {number} enquêtes</strong> aanmaken",
          "one": "<strong>nog een enquête</strong> aanmaken"
        },
        "text_editor": {
          "multiple": "<strong>{more} {number} tekstdocumenten</strong> aanmaken",
          "one": "<strong>nog een tekstdocument</strong> aanmaken"
        },
        "video_recorder": {
          "multiple": "<strong>{more} {number} video-opnames</strong> maken",
          "one": "<strong>nog een video-opname</strong> maken"
        },
        "website": {
          "multiple": "<strong>{more} {number} websites</strong> aanmaken",
          "one": "<strong>nog een website</strong> aanmaken"
        },
        "word_clouds": {
          "multiple": "<strong>{more} {number} woordwolken</strong> aanmaken",
          "one": "<strong>nog een woordwolk</strong> aanmaken"
        },
        "worksheet": {
          "multiple": "<strong>{more} {number} werkbladen</strong> aanmaken",
          "one": "<strong>nog een werkblad</strong> aanmaken"
        }
      },
      "activation": {
        "question": "Heeft jouw instelling al een licentie?",
        "success": "Licentie succesvol geactiveerd! Je bent nu lid van \"{groupTitle}\"."
      },
      "upsellCard": {
        "group": {
          "description": "De groepslicentie is al voordelig vanaf 5 personen.",
          "linkText": "Informatie over de groepslicentie",
          "linkUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/",
          "title": "Samen met collega's"
        },
        "individual": {
          "description": "Ontdek alle aanbiedingen voor jou als individuele leerkracht.",
          "linkText": "Informatie over de individuele licentie",
          "linkUrl": "https://app.fobizz.com/pricing",
          "title": "Individueel voor jou"
        }
      }
    },
    "links": {
      "accept": "Ik heb de informatie ter kennis genomen",
      "aiAssistants": "AI-Assistenten",
      "aiImageSearch": "Mijn AI-Afbeeldingen",
      "back": "Terug",
      "back_to_curriculum": "Terug naar overzicht",
      "clickToEdit": "Klik om te bewerken",
      "close": "Sluiten",
      "copied": "Gekopieerd!",
      "copy": "Kopiëren",
      "create": "Aanmaken",
      "createNew": "Nieuw aanmaken",
      "createTool": "{name} aanmaken",
      "createWithTemplate": "Sjabloon kiezen",
      "createWithoutTemplate": "Aanmaken",
      "dataProtection": "Privacy",
      "delete": "Verwijderen",
      "discard": "Naar prullenbak verplaatsen",
      "download": "Downloaden",
      "downloadCSV": "Downloaden als CSV",
      "duplicate": "Dupliceren",
      "edit": "Bewerken",
      "exportAs": {
        "docx": "Exporteren naar Word",
        "pdf": "Exporteren naar PDF",
        "pptx": "Exporteren naar PowerPoint"
      },
      "freeRegistration": "Nu registreren",
      "gallery": "Galerij",
      "generateWithAi": "Genereren met AI",
      "history": "Geschiedenis",
      "imageSearch": "Afbeeldingen zoeken",
      "imageSearchPexels": "Afbeeldingen zoeken via Pexels",
      "imageSearchPixabay": "Afbeeldingen zoeken via Pixabay",
      "imprint": "Colofon",
      "learnMore": "Meer informatie",
      "legal": "Juridisch",
      "licenseInfo": "Licentie-info",
      "logout": "Uitloggen",
      "moreSettings": "Meer instellingen",
      "move": "Verplaatsen",
      "moveToFolder": "Verplaatsen naar map",
      "new": "Aanmaken",
      "open": "Openen",
      "openAttachment": "Bijlage openen",
      "openRow": "{name} openen",
      "overview": "Overzicht",
      "preview": "Voorbeeld",
      "print": "Afdrukken",
      "remix": "Remix",
      "remove": "Verwijderen",
      "reportContent": "Inhoud melden",
      "saveImage": "Afbeelding opslaan",
      "savePdf": "PDF opslaan",
      "search": "Zoeken",
      "settings": "Instellingen",
      "share": "Delen",
      "showAll": "Alles tonen",
      "showMore": "Meer tonen",
      "showQrCode": "QR-code tonen",
      "signup": "Registreren",
      "templateToggle": "Als sjabloon gebruiken",
      "termsAndConditions": "Algemene voorwaarden",
      "themeEditor": "Achtergrond aanpassen",
      "toolInfos": "Tutorial en hulp",
      "tryNow": "Nu uitproberen",
      "undiscard": "Herstellen",
      "uploadFile": "Bestand uploaden",
      "uploadImage": "Afbeelding uploaden"
    },
    "palette": {
      "noColor": "Geen kleur",
      "noPattern": "Geen patroon"
    },
    "placeholders": {
      "anonymous": "Anoniem",
      "answer": "Antwoord hier invoeren...",
      "description": "Beschrijving hier invoeren...",
      "password": "Wachtwoord invoeren...",
      "question": "Vraag hier invoeren...",
      "selectOption": "Selecteer alstublieft"
    },
    "preview": {
      "editLink": "Materiaal bewerken",
      "hint": "Je bevindt je in de voorbeeldweergave.",
      "title": "Voorbeeld"
    },
    "profileStatus": {
      "licenses": {
        "courses": {
          "basic": {
            "label": "Basiscursussen",
            "tooltip": "Je kunt de gratis cursussen gebruiken. Als je toegang wilt tot alles, raden we je de Cursus-Flatrate of de Cursus-schoollicentie aan."
          },
          "group": {
            "label": "Cursus-schoollicentie",
            "tooltip": "Je hebt de Cursus-schoollicentie. Hiermee kun je alle cursussen gebruiken."
          },
          "pro": {
            "label": "Cursus-Flatrate",
            "tooltip": "Je hebt de Cursus-Flatrate. Hiermee kun je alle cursussen gebruiken."
          }
        },
        "tools": {
          "basic": {
            "label": "Basis-tools",
            "tooltip": "Je kunt de tools gebruiken, maar met een limiet per tool. Als je alle tools onbeperkt wilt gebruiken, raden we je de Tools-Flatrate of de Tools-schoollicentie aan."
          },
          "group": {
            "label": "Tools-schoollicentie",
            "tooltip": "Je hebt de Tools-schoollicentie. Hiermee kun je de tools zonder limiet gebruiken."
          },
          "pro": {
            "label": "Tools-Flatrate",
            "tooltip": "Je hebt de Tools-Flatrate. Hiermee kun je de tools zonder limiet gebruiken."
          }
        }
      }
    },
    "qrcodeModal": {
      "title": "QR-Code"
    },
    "remixModal": {
      "alert": "Bij deze assistent is de achtergrondkennis niet vrijgegeven om te remixen. Je kunt eenvoudig je eigen context toevoegen.",
      "button": "Inhoud nu remixen",
      "licenseHint": "Let op: Deze inhoud valt onder de Creative Commons-licentie CC-BY, d.w.z. je moet de auteur(s) vermelden bij hergebruik.",
      "loginPrompt": "Log in op je fobizz-account om deze inhoud te remixen en te gebruiken voor je eigen lessen.",
      "paragraph": "Met de remix-optie maak je een eigen kopie van deze inhoud en kun je deze bewerken en aanpassen.",
      "hint": "⏳ Let op: Bij grote inhoud kan het remixen even duren - het proces loopt op de achtergrond verder. Je vindt de inhoud later terug in je opslag.",
      "toLogin": "Naar fobizz inloggen"
    },
    "response": {
      "labels": {
        "submission": "Inlevering | Inleveringen"
      }
    },
    "settingsModal": {
      "labels": {
        "autoCleanup": "{modelName} wordt na deze periode verwijderd:"
      }
    },
    "shareOptions": {
      "buttons": {
        "create24hProject": "Klaslokaal • 24 uur",
        "createSchoolClass": "Klaslokaal • 1 jaar",
        "selectProject": "Klaslokaal en project selecteren",
        "shareInSchoolClass": "Delen in klaslokaal",
        "showQRCode": "QR-code weergeven"
      },
      "defaultNames": {
        "project24h": "Jouw 24-uursproject"
      },
      "hints": {
        "alreadyShared": "Je hebt deze inhoud al in dit project gedeeld. Kies een ander project.",
        "error": "Er is een fout opgetreden bij het bijwerken van het klaslokaal. Probeer het opnieuw.",
        "errorShareSettings": "Er is een fout opgetreden bij het opslaan van de deelexemplaren. Probeer het opnieuw.",
        "locked": "Inhoud vergrendeld. Alleen jij kunt het zien en bewerken.",
        "noSchoolClass": "Je hebt nog geen klaslokaal aangemaakt. Maak er een aan om inhoud te delen.",
        "password_protected": "Deellink is beveiligd met een wachtwoord.",
        "public_for_all": "Inhoud is vrijgegeven als OER en gepubliceerd in de fobizz galerij.",
        "schoolClassWithoutProject": "Je hebt nog geen project aangemaakt voor dit klaslokaal. Maak een project aan om inhoud te delen.",
        "secret": "Inhoud is toegankelijk via deellink.",
        "sharedInClassroom": "Gedeeld in het klaslokaal.",
        "invitedBy": "Uitnodiging van {name}",
        "discardedByOwner": "Verwijderd door {name}",
        "success": "Je klaslokaal is bijgewerkt.",
        "successRemove": "Inhoud is verwijderd uit je klaslokaal."
      },
      "labels": {
        "categories": "Categorieën",
        "iFrame": "Via iFrame",
        "project": "Project",
        "schoolClass": "In het klaslokaal",
        "shareInSchoolClass": "Inhoud delen in klaslokaal",
        "shareLink": "Via deellink",
        "shareSpace": "Klaslokaal",
        "sharingSettings": "Deelinstellingen"
      },
      "options": {
        "select": "Selecteren"
      }
    },
    "spinnerDialog": {
      "text": "Het duurt nog even"
    },
    "stockImageTypes": {
      "illustration": "Illustratie",
      "photo": "Foto",
      "vector": "Vector"
    },
    "templatesModal": {
      "emptyHint": "Je hebt nog geen eigen sjablonen opgeslagen.",
      "header": "Sjablonen",
      "paragraph": "Begin met een eigen sjabloon of een sjabloon van fobizz.",
      "tabFobizzTemplates": "fobizz Sjablonen",
      "tabYourTemplates": "Eigen sjablonen"
    },
    "time": {
      "oClock": "Klok",
      "today": "Vandaag",
      "tomorrow": "Morgen"
    },
    "pseudonymModal": {
      "titles": {
        "pupil_feedback": "AI-Feedback"
      }
    },
    "visitorPermissions": {
      "visitor_permissions_invisible": "Verborgen",
      "visitor_permissions_read": "Lezen",
      "visitor_permissions_write": "Schrijven"
    }
  }
}
